/**
 * Pixelgipfel Merkliste (Wishlist).
 * - Gäste: localStorage 'pg:wish' (Produkt-Handles)
 * - Eingeloggte Kunden: server-side über /apps/wishlist/toggle (Storefront API oder App Proxy)
 * - Alternative Fallback: localStorage bleibt auch bei eingeloggten Usern gültig,
 *   Sync passiert opportunistisch beim nächsten Reload.
 *
 * Heart-Toggle:
 *   <button data-pg-wish-toggle data-product-handle="gipfel-9">…</button>
 */
(function () {
  'use strict';
  var KEY = 'pg:wish';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('pg:wish-updated', { detail: { count: list.length, list: list } }));
  }

  function toggle(handle) {
    var list = read();
    var idx = list.indexOf(handle);
    if (idx >= 0) list.splice(idx, 1);
    else list.push(handle);
    write(list);
    return list.indexOf(handle) >= 0;
  }

  function syncStates() {
    var list = read();
    document.querySelectorAll('[data-pg-wish-toggle]').forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      var on = list.indexOf(h) >= 0;
      btn.setAttribute('data-pg-in-wish', on ? 'true' : 'false');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-pg-wish-count]').forEach(function (el) {
      el.textContent = String(list.length);
    });
  }

  function wire() {
    document.querySelectorAll('[data-pg-wish-toggle]').forEach(function (btn) {
      if (btn.dataset.pgWishWired === '1') return;
      btn.dataset.pgWishWired = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var h = btn.getAttribute('data-product-handle');
        if (!h) return;
        toggle(h);
        syncStates();
      });
    });
  }

  document.addEventListener('pg:wish-updated', syncStates);
  document.addEventListener('shopify:section:load', function () { wire(); syncStates(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); syncStates(); });
  } else {
    wire();
    syncStates();
  }
})();
